import React, { useState, useEffect } from 'react';
import eventBus from '../../eventBus';
import ExtrasModal from '../modal/ExtrasModal';
import ThreeDViewer from '../modal/ThreeDViewer';

const FoodItem = ({ id, media, name, price, discount_price, category_id, ingredients, has_extras, extrasfoods, showAlertModal, image_3d_data }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [is3DModalOpen, set3DModalOpen] = useState(false);
  const [frames, setFrames] = useState([]);

  // Генерация кадров для 3D анимации
  useEffect(() => {
    if (image_3d_data && image_3d_data.main && image_3d_data.count) {
      const mainUrl = image_3d_data.main;
      const count = image_3d_data.count - 1;

      const fileName = mainUrl.split('/').pop();
      const nameWithoutExt = fileName.replace(/\.[^/.]+$/, '');
      const folderPath = mainUrl.replace(fileName, `${nameWithoutExt}.3d/`);

      const generatedFrames = [];
      for (let i = 0; i < count; i++) {
        generatedFrames.push(`${folderPath}${nameWithoutExt}.3d.100.${i}.jpg`);
      }

      setFrames(generatedFrames);
    }
  }, [image_3d_data]);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
  const open3DModal = () => set3DModalOpen(true);

  const addToCart = () => {
    const storedCart = JSON.parse(localStorage.getItem('cartItems')) || [];

    const currentRestaurant = JSON.parse(localStorage.getItem('currentRestaurantInfo'));
    const cartRestaurant = JSON.parse(localStorage.getItem('cartRestaurantInfo'));

    const cartShop = JSON.parse(localStorage.getItem('cartShopInfo'));

    if (cartShop) {
      showAlertModal("Уведомление!", `Нужно закончить оформление заказа в магазине ${cartShop.shopName}!`);
      return;
    }

    if (cartRestaurant && currentRestaurant && currentRestaurant.restaurantName !== cartRestaurant.restaurantName) {
      showAlertModal("Уведомление!", `Нужно закончить оформление заказа в ресторане ${cartRestaurant.restaurantName}!`);
      return;
    }

    if (currentRestaurant && currentRestaurant.restaurant_has_worked === false) {
      showAlertModal("Уведомление!", `Ресторан закрыт!`);
      return;
    }

    localStorage.setItem('cartRestaurantInfo', JSON.stringify(currentRestaurant));
    localStorage.removeItem('cartShopInfo');

    const existingItem = storedCart.find(item => item.food_id === id);

    if (existingItem) {
      increaseQuantity(storedCart, existingItem);
    } else {
      addItemToCart(storedCart);
    }
  };

  const handleAddToCartWithExtras = (cartItem) => {
    const storedCart = JSON.parse(localStorage.getItem('cartItems')) || [];
    const currentRestaurant = JSON.parse(localStorage.getItem('currentRestaurantInfo'));
    const cartRestaurant = JSON.parse(localStorage.getItem('cartRestaurantInfo'));

    const cartShop = JSON.parse(localStorage.getItem('cartShopInfo'));

    if (cartShop) {
      showAlertModal("Уведомление!", `Нужно закончить оформление заказа в магазине ${cartShop.shopName}!`);
      return;
    }

    if (cartRestaurant && currentRestaurant && currentRestaurant.restaurantName !== cartRestaurant.restaurantName) {
      showAlertModal("Уведомление!", `Нужно закончить оформление заказа в ресторане ${cartRestaurant.restaurantName}!`);
      return;
    }

    if (currentRestaurant && currentRestaurant.restaurant_has_worked === false) {
      showAlertModal("Уведомление!", `Ресторан закрыт!`);
      return;
    }

    localStorage.setItem('cartRestaurantInfo', JSON.stringify(currentRestaurant));

    storedCart.push(cartItem);
    localStorage.setItem('cartItems', JSON.stringify(storedCart));
    eventBus.publish('cartItemAdded', cartItem);

    closeModal();
  };

  const addItemToCart = (storedCart) => {
    const uniqueId = `${id}-${new Date().getTime()}`;

    const newItem = {
      uniqueId,
      id: null,
      imageUrl: media.url,
      name,
      price: discount_price || price,
      quantity: 1,
      food_id: id,
      category_id,
      extras: []
    };

    storedCart.push(newItem);
    localStorage.setItem('cartItems', JSON.stringify(storedCart));
    eventBus.publish('cartItemAdded', newItem);
  }

  const increaseQuantity = (storedCart, cartItem) => {
    cartItem.quantity += 1;

    const updatedCart = storedCart.map((item) =>
      item.food_id === id ? { ...item, quantity: cartItem.quantity } : item
    );
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));

    const priceChange = storedCart.find((item) => item.food_id === id).price;

    eventBus.publish('cartItemQuantityUpdated', { food_id: id, localQuantity: cartItem.quantity, priceChange });
  }

  return (
    <div className="q-intersection example-item">
      <div className="q-card q-ma-sm section-shop__goods-item">
        <div className="section-shop__goods-block-img">
          <img src={media ? media.url : ''} alt="Food" className="section-shop__goods-img" />
          {frames.length > 0 && (
            <button className="btn btn-3d-icon" onClick={open3DModal}>3D</button>
          )}
          <div className="section-shop__goods-composition-block text-center">
            <h6 className="section-shop__goods-composition-heading">Состав</h6>
            <span className="section-shop__goods-composition-text">{name}</span>
            <span className="section-shop__goods-composition-text" dangerouslySetInnerHTML={{ __html: ingredients }}></span>
          </div>
        </div>
        <div className="q-card__section q-card__section--vert q-pa-none">
          <div className="section-shop__goods-info">
            <h3 className="sectoin-shop__goods-heading">{name}</h3>
          </div>
        </div>
        <div className="q-card__section q-card__section--vert q-pa-none section-shop__goods-btn" bottom="">
          <div className="section-shop__goods-btn">
            {has_extras ? (
              <button className="btn" onClick={openModal}>
                В корзину {discount_price ? `${discount_price} ₽ ` : ''}<span style={{ textDecoration: discount_price ? 'line-through' : 'none' }}>{price} ₽</span>
              </button>
            ) : (
              <button className="btn" onClick={addToCart}>
                В корзину {discount_price ? `${discount_price} ₽ ` : ''}<span style={{ textDecoration: discount_price ? 'line-through' : 'none' }}>{price} ₽</span>
              </button>
            )}
          </div>
        </div>
      </div>

      {isModalOpen && (
        <ExtrasModal
          id={id}
          image={media.url}
          name={name}
          price={price}
          discount_price={discount_price}
          extras={extrasfoods}
          onClose={closeModal}
          onAddToCart={handleAddToCartWithExtras}
        />
      )}

      {is3DModalOpen && frames.length > 0 && (
        <ThreeDViewer
          frames={frames}
          onClose={() => set3DModalOpen(false)}
        />
      )}
    </div>
  );
};

export default FoodItem;
